import styled from 'styled-components';

export const ModalText = styled.div`
  max-width: 600px;

  & > p {
    margin-bottom: 0.5rem;
  }

  & > p:nth-child(2),
  & > p:nth-child(3) {
    padding-left: 1.5rem;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const ModalSearch = styled.div`
  margin: 1rem 0px;
  max-width: 300px;
`;

export const ModalGridContainer = styled.div`
  width: 100%;
  height: 440px;

  .ag-theme-alpine {
    --ag-wrapper-border-radius: 0px;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  .ag-theme-alpine .ag-header {
    border-radius: 8px 8px 0 0;
  }

  .ag-theme-alpine .ag-row:last-child .ag-cell {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const gridStyle = {
  width: '100%',
  height: '100%',
  '--ag-border-color': 'transparent',
  '--ag-row-border-color': 'transparent',
  '--ag-header-background-color': 'rgba(243, 244, 246, 1)',
  '--ag-odd-row-background-color': 'rgba(243, 244, 246, 1)',
  '--ag-even-row-background-color': '#FFFFFF'
};
